import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Gr8piFormattedDateTime } from '../Gr8piFormattedDateTime';

const messages = defineMessages({
  unknown: { id: 'candidate.status.', defaultMessage: 'Unknown' },
  new: { id: 'candidate.status.NEW', defaultMessage: 'New' },
  invited: { id: 'candidate.status.INVITED', defaultMessage: 'Invited' },
  started: { id: 'candidate.status.STARTED', defaultMessage: 'In progress' },
  assessed: { id: 'candidate.status.ASSESSED', defaultMessage: 'Assessed' },
  submitted: { id: 'candidate.status.SUBMITTED', defaultMessage: 'Assessed' },
  declined: { id: 'candidate.status.DECLINED', defaultMessage: 'Declined' },
  expired: { id: 'candidate.status.EXPIRED', defaultMessage: 'Expired' },
});

const BoxHistory = ({ status, date }) => {
  const { formatMessage } = useIntl();

  const safeStatus = `${status}` === '' ? 'unknown' : status.toLowerCase();
  return (
    <div className="vertList-item">
      <div className="p-grid p-justify-between">
        <div className="p-col-5">
          <span className="vertList-main">
            <span className={`assessment assessment-${safeStatus}`}> {formatMessage(messages[safeStatus])}</span>
          </span>
        </div>
        <div className="p-col-5 align-right">
          <span className="vertList-addon vertList-addon--date">
            {date && <Gr8piFormattedDateTime dateValue={date} />}
          </span>
        </div>
      </div>
    </div>
  );
};

BoxHistory.propTypes = {
  status: PropTypes.string.isRequired,
  date: PropTypes.objectOf(PropTypes).isRequired,
};

export default BoxHistory;
